import React from 'react';

import { useCommonStyles } from '@styles';
import { useErrorMessage } from '@utils/forms';
import clsx from 'clsx';

export interface ErrorMessageProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  const { name, className, style } = props;

  const classes = useCommonStyles();

  const message = useErrorMessage(name);

  if (typeof message !== 'string') return null;

  return (
    <div className={clsx(classes.smallerText, classes.textError, className)} style={style}>
      {message}
    </div>
  );
};
